import React from 'react';
export function Ginger({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-59">
      <path d="M30 40C20 30 10 40 15 50C10 60 20 70 30 60C35 75 50 80 60 70C75 80 90 70 85 55C95 45 85 30 75 35C70 20 50 15 45 30C35 20 25 25 30 40Z" opacity="0.7" data-id="element-60" />
      <path d="M25 45Q35 40 40 50" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.3" data-id="element-61" />
      <path d="M45 65Q55 55 65 60" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.3" data-id="element-62" />
      <path d="M60 35Q70 45 80 40" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.3" data-id="element-63" />
    </svg>;
}